export const AgingBucket = {
  flow: 'x',
  gap: 'A',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  CurrentBucket: {
    flex: '1',
    flow: 'y',
    gap: 'Y',
    align: 'center center',
    padding: 'A',
    Label: { text: '{{ current | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
    Amount: { text: (el, s) => s.currentAmount || '$0', fontSize: 'B', fontWeight: '700', color: 'green' },
    Count: { text: (el, s) => s.currentCount ? `${s.currentCount} accounts` : '', fontSize: 'Y', color: 'inkMuted' }
  },

  ThirtyBucket: {
    flex: '1',
    flow: 'y',
    gap: 'Y',
    align: 'center center',
    padding: 'A',
    Label: { text: '{{ thirtyDay | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
    Amount: { text: (el, s) => s.thirtyAmount || '$0', fontSize: 'B', fontWeight: '700', color: 'amber' },
    Count: { text: (el, s) => s.thirtyCount ? `${s.thirtyCount} accounts` : '', fontSize: 'Y', color: 'inkMuted' }
  },

  SixtyBucket: {
    flex: '1',
    flow: 'y',
    gap: 'Y',
    align: 'center center',
    padding: 'A',
    Label: { text: '{{ sixtyDay | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
    Amount: { text: (el, s) => s.sixtyAmount || '$0', fontSize: 'B', fontWeight: '700', color: 'amber' },
    Count: { text: (el, s) => s.sixtyCount ? `${s.sixtyCount} accounts` : '', fontSize: 'Y', color: 'inkMuted' }
  },

  NinetyPlusBucket: {
    flex: '1',
    flow: 'y',
    gap: 'Y',
    align: 'center center',
    padding: 'A',
    Label: { text: '{{ ninetyPlus | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
    Amount: { text: (el, s) => s.ninetyAmount || '$0', fontSize: 'B', fontWeight: '700', color: 'red' },
    Count: { text: (el, s) => s.ninetyCount ? `${s.ninetyCount} accounts` : '', fontSize: 'Y', color: 'inkMuted' }
  }
}
